module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/coj_d-4-c3ca102689830fc3f0b39506bfbb8362.jpg";